import React, { useEffect, useState } from "react";
import { MdDeleteForever } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const MyItem = () => {
  const navigate = useNavigate();

  const [products, setproduct] = useState([]);
  useEffect(() => {
    fetch(`http://localhost:5000/items`)
      .then((response) => response.json())
      .then((data) => setproduct(data));
  }, []);

  const deleteHandeler = (id) => {
    const confirm = window.confirm("Are You Sure");
    if (confirm) {
      fetch(`http://localhost:5000/items/${id}`, {
        method: "delete",
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.deletedCount > 0) {
            navigate("/");
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: "Your product has been delete",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
    }
  };
  return (
    <div>
      <p className="text-4xl mb-5 text-center text-cyan-800 font-bold pt-1">
        My Total Item: {products.length}
      </p>
      <div>
        <div className="pt-10 grid md:grid-cols-2  gap-3 py-10">
          {products.map((product) => (
            <div key={products._id}>
              <div class="card w-96 bg-base-100 shadow-xl transition ease-in-out delay-100 hover:-translate-y-1 hover:scale-110 duration-300">
                <figure class="px-10 pt-10">
                  <img
                    src={product.image}
                    alt="Shoes"
                    className="rounded-xl h-[200px]"
                  />
                </figure>
                <div class="card-body items-center text-center">
                  <h2 class="card-title">{product.name}</h2>
                  <p>Email: {product.email}</p>
                  <p>Price: {product.price}</p>
                  <p>Quantity: {product.quantity}</p>
                  <div class="card-actions">
                    <button
                      onClick={() => deleteHandeler(product._id)}
                      className=" text-red-600 text-4xl  rounded-xl"
                    >
                      <MdDeleteForever />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {/* {products.map((product) => (
            <div key={products._id}>
              <img className="h-[100px] w-[100px]" src={product.image} alt="" />
              <p>Name:{product.name}</p>
              <p>Email: {product.email}</p>
              <p>Price: {product.price}</p>
              <p>Quantity: {product.quantity}</p>

              <button
                onClick={() => deleteHandeler(product._id)}
                className=" text-red-600 text-4xl p-2  rounded-xl ml-36"
              >
                <MdDeleteForever />
              </button>
            </div>
          ))} */}
        </div>
      </div>
    </div>
  );
};

export default MyItem;
